import { WelcomeMsgToCorporateUserComponent } from './../shared/welcome-msg-to-corporate-user/welcome-msg-to-corporate-user.component';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild, HostBinding, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { AccountService } from '../services/account.service';
import { OpenDialog } from '../shared/dialogs/dialog';
import { filter } from 'rxjs/operators';
import { ImportantNoticeComponent } from './shared/important-notice/important-notice.component';
import { MatDialog } from '@angular/material/dialog';
import { ScrollToTop } from '../utils/functions';
@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
})
export class PortalComponent implements AfterViewInit, OnInit, OnDestroy {
  // @HostBinding('class.portal') true;
  @HostBinding('class.portal') portalClass = true;

  @ViewChild('outlet') pageOutlet: RouterOutlet;
  currentUser: any;
  toggle = false;
  hide;
  myLandbot;
  refreshDataInterval;
  newUser;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private accountService: AccountService,
    private route: ActivatedRoute,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialogRef: MatDialog
  ) {
    if (window.innerWidth < 769) {
      this.document.body.classList.add('sidebar-collapse-in');
      this.accountService.emit(true);
    }

    this.accountService.emitChange.subscribe((status) => (this.toggle = status));
  }

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();
    clearTimeout(this.refreshDataInterval);
    localStorage.setItem('passport', this.currentUser.passport);
    localStorage.setItem('nic', this.currentUser.passport);
    // newUser
    this.route.queryParams.subscribe((params) => {
      if (params.newUser) {
        this.newUser = true;
      }
    });

    if (this.currentUser.diaplayNewFeatureAlert) {
      await OpenDialog(ImportantNoticeComponent, { featureStatus: this.currentUser.diaplayNewFeatureAlert });
    }

    this.accountService.userSavedDataLoaded = undefined;
    this.accountService.userSavedDataLoadingPromise = undefined;
  }
  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.refreshDataInterval);
  }

  ngAfterViewInit() {
    this.route.url.subscribe((url) => {
      ScrollToTop();
    });
    this.route.params.subscribe((url) => {
      ScrollToTop();
    });
  }
  toggleMenu(e) {
    this.toggle = e;
  }

  onMobileMenuToggle(isOpen: boolean) {
    // This will be handled by the side menu component through the body class
  }

  closeMobileMenu() {
    if (this.document.body.classList.contains('mobile-menu-open')) {
      this.document.body.classList.remove('mobile-menu-open');
      this.document.body.style.overflow = '';
    }
  }

  ngOnDestroy() {
    clearTimeout(this.refreshDataInterval);
    this.dialogRef.closeAll();
    if (document.getElementsByClassName('LandbotLivechat') && document.getElementsByClassName('LandbotLivechat')[0]) {
      document.getElementsByClassName('LandbotLivechat')[0].remove();
    }
  }
}
